const styles = {
    inputLabel: {
        fontWeight: 600,
        width: '100%',
        flex: 1,
        marginTop: 10
    }
};

export default styles;
